export const homePage = {
    path: '/homePage',
    name: 'homePage',
    title: '首页',
    component: () => import("../components/page/homePage/homePage"),
    meta:{title:'首页'},
}


// WEBPACK FOOTER //
// ./src/router/homePage.js